module.exports = __webpack_public_path__ + "img/insurancebg-3.79487380.jpg";